const ClassifiedCardSkel = () => (
  <div className="w-[210px] aspect-9/13 bg-neutral-100 animate-pulse rounded-lg"></div>
);

export default ClassifiedCardSkel;
